// extracted by css-extract-rspack-plugin
export default {"Header":"DockedSidePanel-module__Header__oXFuk","HeaderContent":"DockedSidePanel-module__HeaderContent__nnP_h","Heading":"DockedSidePanel-module__Heading__V9v81"};